// Reads user's roles + permissions dari useState('user-access') yang di-populate
// oleh plugins/load-user-access.ts. Sebelumnya read dari session.user.permissions,
// tapi itu bikin cookie melar > 4096 char untuk user dengan banyak permissions
// dan browser tolak Set-Cookie → user effectively logged out. Sekarang permissions
// tidak di-cookie, hanya di FE state (loaded via /api/auth/me response body).
export function usePermissions() {
  const access = useState<{ roles: string[]; permissions: string[] }>('user-access', () => ({ roles: [], permissions: [] }))

  const permissions = computed<string[]>(() => Array.isArray(access.value?.permissions) ? access.value.permissions : [])
  const roles       = computed<string[]>(() => Array.isArray(access.value?.roles)       ? access.value.roles       : [])

  const can = (...keys: string[]) => {
    const set = new Set(permissions.value)
    return keys.every(k => set.has(k))
  }

  const canAny = (...keys: string[]) => {
    const set = new Set(permissions.value)
    return keys.some(k => set.has(k))
  }

  const isAdmin = computed(() => roles.value.includes('Admin'))

  return { permissions, roles, can, canAny, isAdmin }
}
